var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 17.2917C2.5 16.7165 2.96637 16.2501 3.54167 16.2501H16.0417C16.617 16.2501 17.0833 16.7165 17.0833 17.2917C17.0833 17.867 16.617 18.3334 16.0417 18.3334H3.54167C2.96637 18.3334 2.5 17.867 2.5 17.2917ZM5.9301 6.56998C5.5233 6.16319 5.5233 5.50364 5.9301 5.09685L9.0551 1.97185C9.25045 1.7765 9.5154 1.66675 9.79167 1.66675C10.0679 1.66675 10.3329 1.7765 10.5282 1.97185L13.6532 5.09684C14.06 5.50364 14.06 6.16319 13.6532 6.56998C13.2464 6.97678 12.5869 6.97678 12.1801 6.56998L10.8333 5.22322L10.8333 13.1251C10.8333 13.7004 10.367 14.1667 9.79167 14.1667C9.21637 14.1667 8.75 13.7004 8.75 13.1251L8.75 5.22322L7.40324 6.56998C6.99644 6.97678 6.33689 6.97678 5.9301 6.56998Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.a212b9381d1818947e86441c5f53568e.svg";
export { ForwardRef as ReactComponent };